import React from "react";
import { useTranslation } from "react-i18next";
import { FaCalendarCheck } from "react-icons/fa";
import styles from "./BookDemoCTA.module.css";

const DEMO_URL = "https://stylon.online/stylon/add-appointment?service=f0159974-26e3-4158-99d9-233e300eceff&ref=demo";

const BookDemoCTA = () => {
  const { t } = useTranslation();
  return (
    <div className={styles.wrap}>
      <p className={styles.label}>{t("callMe.demoLabel")}</p>
      <a
        href={DEMO_URL}
        target="_blank"
        rel="noopener noreferrer"
        className={styles.btn}
      >
        <FaCalendarCheck />
        {t("callMe.bookDemo")}
      </a>
    </div>
  );
};

export default BookDemoCTA;
